module.exports = __webpack_public_path__ + "img/avm4x-td4g6.a2eef39d.webp";